import { FirebaseDocChangeType } from 'firebase/index'
import { StoreShippingType } from 'types/storeShipping'
import { Action, Dispatch } from 'redux'
import { fetchStoreShippingsAction } from 'reducks/storeShipping/actions'

const mergeListeningStoreShippings = (
  changes: FirebaseDocChangeType[],
  currentStoreShippings: StoreShippingType[],
  dispatch: Dispatch<Action>
): void => {
  const storeShippings: StoreShippingType[] = currentStoreShippings
  for (let i = 0; i < changes.length; i = (i + 1) | 0) {
    const change = changes[i]
    const data = change.doc.data() as StoreShippingType
    // 同じ注文番号がすでに存在する場合は追加しない
    if (storeShippings.some((storeShipping) => storeShipping.shipping_number === data.shipping_number)) continue
    data.ref = change.doc.ref
    storeShippings.push(data)
  }
  if (storeShippings.length > 0) {
    dispatch(fetchStoreShippingsAction(storeShippings))
  }
}

export default mergeListeningStoreShippings
